module.exports = __webpack_public_path__ + "static/media/ripley-crossmod-kitchendetails-stainless-steel-sink.b02766c8.webp";